import { Bot } from "@/entities/bot";
import type { Roles } from "@/entities/user";

export interface LeadLink {
  _id: string;
  owner: string;
  name: string;
  description: string | null;
  costs: number;
  hitCount: number;
  leadsCount: number;
  depositsCount: number;
  redepositsCount: number;
  totalProfit: number;
  type: LeadLinkType;
  target: LeadLinkTarget;
  status: LeadLinkStatus;
  bot?: Bot;
  createdAt: Date;
  updatedAt: Date;
  url: string;
  statistics: LeadLinkStatistics;
  metrics: LeadLinkMetrics;
}

export interface LinkV2 {
  id: string;
  botId: string;
  costs: number;
  createdAt: string;
  depositsCount: number;
  description: string;
  hitCount: number;
  isPartnerPermittedToEdit: boolean;
  leadsCount: number;
  name: string;
  ownerId: string;
  partnerId: string;
  partnerRate: number;
  redepositsCount: number;
  status: LeadLinkStatus;
  target: LeadLinkTarget;
  totalProfit: number;
  type: LeadLinkType;
  updatedAt: string;
}

export interface LeadLinkStatistics {
  total: number;
  rejected: number;
  fresh: number;
  surveyCompleted: number;
  removedBySurvey: number;
  texted: number;
  ignore: number;
  hadCall: number;
  spinning: number;
  deposit: number;
}

export interface LeadLinkMetrics {
  conversion: number;
  averageDeposit: number;
  averageProfit: number;
  earnPerLead: number;
  earnPerHit: number;
  earnPerSms: number;
  costPerLead: number;
  costPerHit: number;
  costPerSms: number;
}

export type LeadLinkTarget =
  | "bot-survey"
  | "bot-public"
  | "site-bot"
  | "site-public"
  | "neutral-bot"
  | "neutral-site"
  | "axyon-site"
  | "axyon-bot"
  | "constructor-bot"
  | "remote-pro-bot"
  | "astreon-bot"
  | "p2p-work"
  | "wavium-bot"
  | "wavium-site"
  | "vibe-team-bot";

export enum LeadLinkStatus {
  ACTIVE = "active",
  PENDING = "pending",
  ARCHIVE = "archived",
  DECLINED = "declined",
}

export enum LeadLinkType {
  SITE = "site",
  BOT = "bot",
  PERSONAL = "personal",
}

export interface LeadLinkShares {
  data: {
    _id: string;
    totalAmount: number;
    username: string;
    role: Roles.Worker;
  }[];
}

export interface LeadLinkColumnConfig {
  id: string;
  title: string;
  visible: boolean;
  locked: boolean;
}
